import React from 'react'

import ProjectsReorderList from "../projects-reorder-list"
import NavigationMenuAddWithPopover from "../../../menu-items/menu-add-with-popover/menu-add"
import NavigationMenu_ProjectsLocalSettings from "../../../local-settings"
import ProjectSession from "../../../../../core/model2/project/project-session"
import NavigationMenu_ProjectsInlineAdd from "./inline-add"
import Section from "../../../../../core/model2/project/section"
import MenuProjects_DndRoot from "../dnd/dnd-root"
import {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../../menu-items/menu-add-with-popover/@types"

// const debug = "NavigationMenu_SectionProjectsTree"
const debug = false

type Props = {
    showAdd             : boolean
    localSettings       : NavigationMenu_ProjectsLocalSettings

    section             : Section
}

type State = {
    inlineType?         : NavigationMenuInlineAddType,
    templateId?         : ID
    params              : any
}

export default class NavigationMenu_SectionProjectsTree extends React.Component<Props, State> {

    static defaultProps = {
        showAdd: true
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            inlineType      : undefined,
            templateId      : undefined,
            params          : undefined
        }
    }

    onAddInline = (inlineType: NavigationMenuInlineAddType, params: NavigationMenuInlineAddParams) => {
        debug && console.log(debug, 'onAddInline', inlineType, params)

        this.setState({
            inlineType  : inlineType,
            params      : params, // for folder, page and embed
        })
    }

    onInlineAdded = (isAdded: boolean) => {
        debug && console.log(debug, 'onInlineAdded', isAdded)

        this.setState({
            inlineType  : undefined,
            params      : undefined,
        })
    }

    render() {
        debug && console.log(debug, 'render() section=', this.props.section, this.props.localSettings)

        const showAddButton = this.props.showAdd && !this.state.inlineType && gd.ac.check.canCreateProject(gd.companyId) && gd.ac.check.createRootProject()

        let parentId        : any = this.props.section.project.id
        let rootProjects    : ProjectSession[] = this.props.section.rootProjects

        debug && console.log(debug, '    rootProjects=', rootProjects)

        // make sure we do not show root projects which are starred
        const starredProjects : ID[] = gd.session.starredItems.getProjectsIds() || []
        rootProjects = _.filter(rootProjects, (project:ProjectSession)=>{
            return !starredProjects.includes(project.id)
        })

        return (
            <>
                <MenuProjects_DndRoot>
                    <ProjectsReorderList
                        level           = {0}
                        space           = {this.props.section}
                        parentId        = {parentId}
                        projects        = {rootProjects}
                        localSettings   = {this.props.localSettings}
                    />
                </MenuProjects_DndRoot>

                {showAddButton &&
                    <NavigationMenuAddWithPopover
                        label       = "New"
                        projectId   = {this.props.section.project.id}
                        onAddInline = {this.onAddInline}
                    />}

                {this.state.inlineType &&
                    <NavigationMenu_ProjectsInlineAdd
                        type        = {this.state.inlineType}
                        parentId    = {this.props.section.project.id}
                        params      = {this.state.params}
                        callback    = {this.onInlineAdded}
                    />}
            </>
        )
    }
}
